import React, { FunctionComponent, useState, useEffect } from 'react';
import { Grid, Tabs, Button, Colors, AnalyticsPage } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// Types
import { ItemAccessTypes } from 'ducks/merchantDucks/items/actions';
import InAppIntegrationsState from 'ducks/merchantDucks/inAppIntegrations/types';

// Components
import GeneralPriceInfo from 'pages/MerchantPages/Assets/Price/components/forms/GeneralPriceInfo';
import AdditionalPriceInfo from 'pages/MerchantPages/Assets/Price/components/forms/AdditionalPriceInfo';

enum PriceInfoTabs {
  GeneralInfo = 0,
  AdditionalInfo = 1,
}

const { Cell, Container } = Grid;

export const CustomButton = styled(Button)`
  border: none;
  padding: 0px;
  justify-content: flex-start;
  color: ${Colors.fontGray};

  :hover {
    background: none;
    box-shadow: none;
  }
`;

interface Props {
  countrySets: Array<any>;
  accessTypes: ItemAccessTypes;
  paymentType: string;
  accessTypeId: number;
  handleBackToAccessFees: () => void;
  inAppIntegrations: InAppIntegrationsState;
  isEditAccessFeeScreen: boolean;
  geoRestrictionTypeTabIndex: number;
  hasActionError: boolean;
  editSeasonFeeDisabled: boolean;
  isReadOnly: boolean;
  selectedFeeId: number;
  isTemplate: boolean;
}

const priceInfoTabs = [
  { name: 'General info', tag: 'link_general_info' },
  { name: 'Additional info', tag: 'link_additional_info' },
];

const AssetPriceOptions: FunctionComponent<Props> = ({
  accessTypes,
  countrySets,
  paymentType,
  accessTypeId,
  handleBackToAccessFees,
  inAppIntegrations,
  isEditAccessFeeScreen,
  geoRestrictionTypeTabIndex,
  hasActionError,
  editSeasonFeeDisabled,
  isReadOnly,
  selectedFeeId,
  isTemplate,
}) => {
  const [priceInfoActiveTab, setPriceInfoActiveTab] = useState(0);

  useEffect(() => {
    if (hasActionError) {
      setPriceInfoActiveTab(0);
    }
  }, [hasActionError]);

  // Set state for general price info component -> reset select values fix
  const [selectedPaymentType, setPaymentType] = useState(paymentType);
  const [selectedAccessTypeId, setAccessTypeId] = useState(accessTypeId);

  const renderPriceInfoContent = () => {
    return priceInfoActiveTab === PriceInfoTabs.GeneralInfo ? (
      <GeneralPriceInfo
        tag="link_general_info"
        accessTypes={accessTypes}
        paymentType={paymentType}
        accessTypeId={accessTypeId}
        inAppIntegrations={inAppIntegrations}
        isEditAccessFeeScreen={isEditAccessFeeScreen}
        selectedPaymentType={selectedPaymentType}
        setPaymentType={setPaymentType}
        selectedAccessTypeId={selectedAccessTypeId}
        setAccessTypeId={setAccessTypeId}
        editSeasonFeeDisabled={editSeasonFeeDisabled}
        isReadOnly={isReadOnly}
        selectedFeeId={selectedFeeId}
        isTemplate={isTemplate}
      />
    ) : (
      <AdditionalPriceInfo
        tag="link_additional_info"
        geoRestrictionTypeTabIndex={geoRestrictionTypeTabIndex}
        paymentType={selectedPaymentType}
        countrySets={countrySets}
        isReadOnly={isReadOnly}
      />
    );
  };

  return (
    <AnalyticsPage tag={priceInfoTabs[priceInfoActiveTab].tag} type="tab">
      <Container columns={4} rowGap="2rem">
        <Cell middle>
          <CustomButton tag="link_back" buttonModifiers={['buttonLink']} type="button" onClick={handleBackToAccessFees}>
            &larr; back
          </CustomButton>
        </Cell>
        <Cell width={2}>
          <Tabs
            tabs={priceInfoTabs}
            selectedTabIndex={priceInfoActiveTab}
            onTabClick={(i) => setPriceInfoActiveTab(i)}
          />
        </Cell>
        <Cell width={4}>{renderPriceInfoContent()}</Cell>
      </Container>
    </AnalyticsPage>
  );
};

export default AssetPriceOptions;
